/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const SendHorizontal = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m3 3 3 9-3 9 19-9Z" }],
    ["path", { d: "M6 12h16" }]
  ]
];

export { SendHorizontal as default };
//# sourceMappingURL=send-horizontal.js.map
